import { Badge } from "@circleco/compass/components/Badge";
import { Link } from "@circleco/compass/components/Link";

import { t } from "@/i18n-js/instance";
import { isFlagged } from "@/react/components/CommentsCompass/helpers";
import { useAuthorLinkProps } from "@/react/components/CommentsCompass/Thread/Comment/useAuthorLinkProps";
import { cssAnchorProps } from "@/react/helpers/cssAnchorHelpers";
import type { Comment } from "@/react/types/Comment";

import { Tags } from "./Tags";
import { Timestamp } from "./Timestamp";

interface AuthorProps {
  comment: Comment;
}

export const Author = ({ comment }: AuthorProps) => {
  const authorLinkProps = useAuthorLinkProps(comment);
  const headline = comment.community_member.headline;

  return (
    <div
      className="flex flex-col"
      {...cssAnchorProps({ anchor: "comment-author" })}
    >
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <Link
          {...authorLinkProps}
          variant="custom"
          typography="label-sm"
          hoverColor="primary"
          {...cssAnchorProps({ anchor: "comment-author-name" })}
        >
          <span className="overflow-anywhere">
            {comment.community_member.name}
          </span>
        </Link>
        <div className="flex items-center gap-x-2">
          <Tags comment={comment} />
          <Timestamp comment={comment} />
          {isFlagged(comment) && (
            <Badge label={t("comments.in_review")} variant="warning" />
          )}
        </div>
      </div>
      {headline && (
        <div className="inline-flex mb-0.5">
          <Link
            {...authorLinkProps}
            variant="custom"
            typography="caption"
            color="tertiary"
            hoverColor="secondary"
            {...cssAnchorProps({ anchor: "comment-author-headline" })}
          >
            <span className="overflow-anywhere line-clamp-1">{headline}</span>
          </Link>
        </div>
      )}
    </div>
  );
};
